import { useHistory, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import InsightsCards from '../insights-cards/insights-cards.component';
import { useAnalyticsContext } from '../../../../../contexts/analytics/useAnalyticsContext';
import { THEME } from '../../../../../themes';
import { AppRouting } from '../../../../../services/appRoutingResolver';
import { FilledButton } from '../../../../../components/Common/Buttons/filled-button/filled-button.component';
import MatchLimitDailyBase from '../match-daily-limit-base/match-daily-limit.component';
import { ANALYTICS_EVENTS, EVENT_GROUP, PRODUCT_AREA } from '../../../../../consts/analytics';
import STRING_KEYS from '../../../../../language/keys';
import { PAGE_NAMES } from '../../../../../consts/pages';
import { ASSETS } from '../../../../../assets';

const MatchLimitDailyPro = ():JSX.Element | null => {
  const { positionId } = useParams<MatchUrlParams>();
  const browserHistory = useHistory();
  const { t: translate } = useTranslation();
  const { analyticsTrackEvent } = useAnalyticsContext();

  const onClickGoToReachOut = () => {
    const eventData = {
      eventName: ANALYTICS_EVENTS.CLICKED_ON_REACH_YOUR_MATCHES,
      eventGroup: EVENT_GROUP.CLICK,
      pageName: PRODUCT_AREA.MATCH_PAGE,
      productArea: PAGE_NAMES.MATCH_PAGE,
      pagePositionId: positionId,
    };

    analyticsTrackEvent(eventData);
    browserHistory.push(
      AppRouting.buildPositionConversationsPageUrl(positionId),
    );
  };

  const InsightsElement = (
    <InsightsCards
      positionId={ positionId }
    />
  );

  const OutReachToMatches: JSX.Element = (
    <FilledButton
      buttonText={ translate(STRING_KEYS.DAILY_LIMIT.PRO_USER.REACH_OUT_BUTTON) }
      onClick={ onClickGoToReachOut }
      style={ {
        backgroundColor: THEME.COLORS.ACCENT,
        activeBackgroundColor: THEME.COLORS.ACCENT,
        hoveredBackgroundColor: THEME.COLORS.ACCENT,
        uppercase: true,
      } }
    />
  );

  return (
    <MatchLimitDailyBase
      Icon={ <ASSETS.SLOTH_YOGA /> }
      title={ translate(STRING_KEYS.DAILY_LIMIT.PRO_USER.TITLE) }
      description={ translate(STRING_KEYS.DAILY_LIMIT.PRO_USER.DESCRIPTION) }
      FilledButton={ OutReachToMatches }
      InsightsElement={ InsightsElement }
    />
  );
};

export default MatchLimitDailyPro;
